import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import type { IconProps } from "../iconProps.utils";

// FontAwesome's own inline sizing (1em tall, text-aligned), unlike the boxed icons, as the parts page header has it.
export const PartsIcon: React.FC<IconProps> = (props) => <FontAwesomeIcon icon={faBoxOpen as any} {...props} />;
